import { makeStyles } from '@material-ui/core';

export default makeStyles({
  liTopping: ({ hideName }: Props) => ({
    marginTop: hideName ? 0 : '0.25rem',
    '& > p[aria-label="topping-name"]': {
      display: hideName ? 'none' : 'block',
      fontWeight: 600,
    },
  }),
  toppingInfo: {
    display: 'flex',
    columnGap: '0.5rem',
    flexWrap: 'nowrap',
    justifyContent: 'stretch',
    fontWeight: 'normal',
    '& > p[lang]': {
      flexGrow: 1,
    },
  },
});

interface Props {
  hideName: boolean;
}
